import { CLIENT_ADD } from "../action-types/clientActionType";


export const addClient = (payload) => async (dispatch) => {
    dispatch({ type: CLIENT_ADD, payload });
}